/**
 * Japanese (日本語) translations
 * Context: Hibachi catering service for home parties
 */
const ja = {
	nav: {
		home: 'ホーム',
		california: 'カリフォルニア',
		texas: 'テキサス',
		florida: 'フロリダ',
		menu: 'メニュー',
		faq: 'よくある質問',
		freeEstimate: '無料見積もり',
		bookNow: '予約する',
		myBooking: '予約確認',
	},
	seo: {
		homeDescription: '最高評価のご自宅鉄板焼き体験。カリフォルニア、テキサス、フロリダで鉄板焼きグリルとシェフをお届けします。',
	},
	hero: {
		title: 'FAMILY FRIENDS HIBACHI',
		tagline: 'アメリカNo.1の出張鉄板焼き',
		subtitle: 'ご自宅で本格的な日本の鉄板焼きを',
		description: 'プロのシェフが鉄板焼きの醍醐味をお庭まで直接お届けします。',
		bookNow: '今すぐ予約',
		freeEstimate: '無料見積もり',
	},
	howItWorks: {
		title: 'ご利用の流れ',
		subtitle: '完璧な鉄板焼きパーティーへの簡単なステップ',
		step1: { title: 'オンライン予約', description: '日時とメニューをお選びください' },
		step2: { title: '準備はお任せ', description: '食材と機材は全て私たちが用意します' },
		step3: { title: 'ショーを楽しむ', description: 'シェフのパフォーマンスと美味しい料理をお楽しみください' },
		step4: { title: '片付けもお任せ', description: '後片付けは全て私たちが行います' },
	},
	menu: {
		title: 'メニュー',
		subtitle: '新鮮な食材、本格的な味',
		proteins: 'メイン',
		sides: 'サイド＆前菜',
		chicken: 'チキン',
		steak: 'フィレミニョン',
		shrimp: 'エビ',
		salmon: 'サーモン',
		lobster: 'ロブスターテール',
		tofu: '豆腐（ベジタリアン）',
		scallops: 'ホタテ',
		friedRice: '鉄板焼きチャーハン',
		noodles: '焼きそば',
		vegetables: 'グリル野菜',
		salad: 'ジンジャーサラダ',
		soup: '味噌汁',
		edamame: '枝豆',
		includes: {
			salad: 'フレッシュサラダ',
			rice: 'チャーハン',
			vegetables: '鉄板焼き野菜',
			show: 'ゲーム＆ショー',
		},
		protein: {
			title: 'タンパク質の選択',
			included: '含む',
		},
		upgrades: {
			title: 'プレミアムアップグレード',
			filet: 'フィレミニョン',
			lobster: 'ロブスター',
			ribeye: 'プレミアムリブアイ',
			shrimp: 'ジャンボシュリンプ',
			salmon: 'ワイルドサーモン',
			scallops: '大粒ホタテ',
		},
		addons: {
			title: '追加メニュー',
			gyoza: '餃子（12個）',
			edamame: '枝豆',
			noodles: '麺',
			thirdProtein: '3つ目のタンパク質',
		},
		coupon: {
			title: '特別クーポン',
			subtitle: '日曜日〜金曜日のパーティー限定！',
			email: 'メールでお問い合わせ',
		},
		note: {
			outdoor: '屋外でのみ調理します。',
			weather: '雨天でもサービスを提供しますが、シェフが調理できる乾燥した場所が必要です。',
		},
	},
	pricing: {
		title: '料金',
		subtitle: '追加料金なしの明瞭価格',
		perPerson: '1名様',
		minimum: '最少10名様',
		includes: '含まれるもの',
		includesList: {
			chef: 'プロの鉄板焼きシェフ',
			ingredients: '全ての食材と備品',
			equipment: '鉄板グリルと機材',
			setup: 'セットアップと片付け',
			show: 'ライブクッキングショー',
		},
		basic: { title: 'ベーシックパッケージ', description: '少人数の集まりに最適' },
		premium: { title: 'プレミアムパッケージ', description: '完璧な鉄板焼き体験' },
		deluxe: { title: 'デラックスパッケージ', description: '最高級のダイニング' },
	},
	calendar: {
		available: '予約可能',
		limited: '残りわずか',
		busy: '混雑',
		unavailable: '予約不可',
		today: '今日',
		prevMonth: '前月',
		nextMonth: '翌月',
		weekdays: {
			sun: '日',
			mon: '月',
			tue: '火',
			wed: '水',
			thu: '木',
			fri: '金',
			sat: '土',
		},
		months: {
			january: '1月',
			february: '2月',
			march: '3月',
			april: '4月',
			may: '5月',
			june: '6月',
			july: '7月',
			august: '8月',
			september: '9月',
			october: '10月',
			november: '11月',
			december: '12月',
		},
	},
	slider: {
		chef: 'プロの鉄板焼きシェフのパフォーマンス',
		steak: '絶品の鉄板焼きステーキ',
		shrimp: '新鮮な鉄板焼きエビ',
		setup: 'プレミアム鉄板焼きセットアップ',
		presentation: '美しい料理のプレゼンテーション',
	},
	booking: {
		title: 'ご予約',
		subtitle: '地域を選択して開始',
		selectRegion: '地域を選択',
		california: 'カリフォルニア',
		texas: 'テキサス',
		florida: 'フロリダ',
		californiaTagline: 'ご自宅でプロの鉄板焼きを',
		texasTagline: 'テキサスに最高の鉄板焼きを',
		floridaTagline: 'サンシャインステートで鉄板焼き体験',
		servingAreas: 'サービス提供エリア',
		bookIn: '予約する',
		note: '* お支払いは不要です。確認のためご連絡いたします。',
		quickBook: 'クイック予約:',
		summary: '予約詳細',
		addToCalendar: 'カレンダーに追加',
	},
	calculator: {
		title: '料金計算',
		subtitle: '今すぐお見積もり',
		adults: '大人',
		kids: '子供（12歳未満）',
		upgrades: 'プレミアムアップグレード',
		summary: '料金サマリー',
		subtotal: '小計',
		discount: '割引',
		total: '合計',
		gratuity: 'おすすめチップ',
		grandTotal: '総合計',
		bookNow: 'イベント予約',
		note: '* 場所により交通費が発生する場合があります。',
		minimumNotice: '最少10名様必要',
	},
	gallery: {
		title: 'ギャラリー',
		subtitle: 'Family Friends Hibachi の違いを体験',
		items: {
			chef: 'プロの鉄板焼きシェフ',
			chefDesc: 'プロの鉄板焼きシェフのパフォーマンス',
			grill: '鉄板グリルセットアップ',
			grillDesc: 'プレミアム鉄板グリルセットアップ',
			steak: '鉄板焼きステーキ',
			steakDesc: '美味しい鉄板焼きステーキ',
			vegetables: '鉄板焼き野菜',
			vegetablesDesc: '新鮮な鉄板焼き野菜',
			shrimp: '鉄板焼きエビ',
			shrimpDesc: '素晴らしい鉄板焼きエビ',
			food: 'フードプレゼンテーション',
			foodDesc: '美しいフードプレゼンテーション',
		},
	},
	reviews: {
		title: 'お客様の声',
		subtitle: 'Family Friends Hibachi 体験へのお客様の評価',
		bookNow: 'イベント予約',
		ctaTitle: '素晴らしい体験を作る準備はできましたか？',
		ctaText: '数百人の満足したお客様に参加',
		rating: '5.0 平均評価',
		verified: '100+ 確認済みレビュー',
		topRated: '最高評価サービス',
	},
	instagram: {
		title: '私たちをフォロー',
		followUs: 'インスタグラムをフォロー',
	},
	referral: {
		title: '友達紹介で報酬獲得',
		subtitle: '鉄板焼きの楽しさを共有して報酬を獲得！',
		step1Title: 'コードを共有',
		step1Desc: '友人や家族と紹介コードを共有',
		step2Title: '友達が予約',
		step2Desc: '友達は初回予約で$30オフ',
		step3Title: '報酬を獲得',
		step3Desc: '次回イベントに$50クレジット獲得',
		yourReward: 'あなたの報酬',
		friendDiscount: '友達の割引',
		getCode: '紹介コードを取得',
		emailPlaceholder: 'メールを入力',
		invalidEmail: '有効なメールを入力',
		getCodeBtn: 'コード取得',
		successTitle: '紹介コード準備完了！',
		successDesc: 'メールで紹介コードをご確認ください',
		terms: '* 友達が初回予約完了後に報酬適用',
	},
	newsletter: {
		title: '限定特典を受け取る',
		subtitle: '特別割引とパーティーのヒント！',
		placeholder: 'メールアドレスを入力',
		subscribe: '登録',
		invalidEmail: '有効なメールを入力',
		success: 'ご登録ありがとうございます！',
		error: 'エラーが発生しました',
		privacy: 'プライバシーを尊重します',
		benefit1: '限定割引',
		benefit2: 'パーティーのヒント',
		benefit3: '新メニュー情報',
	},
	myBooking: {
		title: '予約確認',
		subtitle: '予約時にご使用のメールアドレスまたは電話番号をご入力ください',
		emailPlaceholder: 'メールアドレスを入力',
		phonePlaceholder: '電話番号を入力',
		search: '予約を検索',
		searching: '検索中...',
		results: '検索結果',
		noResults: '予約が見つかりません',
		error: '検索に失敗しました。再度お試しください',
		bookingId: '予約番号',
		needHelp: 'お困りですか？',
		contactUs: 'ご質問がございましたらお気軽にお問い合わせください',
		pendingNote: '2時間以内にご連絡いたします',
		confirmedNote: 'お会いできるのを楽しみにしております！シェフは30分前に到着します',
	},
	faq: {
		title: 'よくある質問',
		subtitle: '知っておきたいこと',
		q1: 'どの地域でサービスを提供していますか？',
		a1: '現在、カリフォルニア、テキサス、フロリダでサービスを提供しています。お住まいの地域についてはお問い合わせください。',
		q2: '何名まで対応できますか？',
		a2: '最少10名様、最大50名様まで対応可能です。大規模なイベントについてはお問い合わせください。',
		q3: '私が用意するものは何ですか？',
		a3: '会場とゲストをご用意いただくだけで大丈夫です！機材、食材、食器類、セットアップ、片付けは全て私たちが行います。',
		q4: 'どのくらい前に予約すべきですか？',
		a4: '平日は2週間前、週末は3〜4週間前の予約をお勧めします。人気日は早く埋まります！',
		q5: '食事制限に対応できますか？',
		a5: 'はい！ベジタリアンオプションがあり、ほとんどの食事制限に対応できます。予約時にお知らせください。',
		q6: 'キャンセルポリシーは？',
		a6: 'イベント7日以上前のキャンセルは全額返金。3〜6日前は50%返金。3日未満は返金不可。',
	},
	contact: {
		title: 'お問い合わせ',
		subtitle: 'お気軽にご連絡ください',
		phone: '電話',
		email: 'メール',
		hours: '営業時間',
		address: 'サービスエリア',
	},
	footer: {
		description: '本格的な鉄板焼き体験をご自宅へ',
		quickLinks: 'クイックリンク',
		contact: 'お問い合わせ',
		followUs: 'フォロー',
		copyright: '© 2024 Family Friends Hibachi. All rights reserved.',
		allRightsReserved: 'All rights reserved.',
		privacyPolicy: 'プライバシーポリシー',
		termsOfService: '利用規約',
	},
	menuSelection: {
		title: 'お料理タイプを選択',
		subtitle: '全てのお食事にはライス、鉄板焼き野菜、特製ソースが含まれます',
		regular: {
			title: 'レギュラー',
			proteins: 'お一人様2種類のタンパク質',
			service: 'ショー付き、90分サービス',
		},
		premium: {
			title: 'プレミアム',
			proteins: '2種類のプレミアムタンパク質：フィレミニョン、ロブスター、ホタテ',
			service: 'ショー付き、120分サービス',
		},
		catering: {
			title: '大人数イベント',
			note: '50名以上ビュッフェスタイル',
			proteins: 'お一人様2種類のタンパク質',
			service: 'ショー付き、3〜4時間サービス',
		},
		intimate: {
			title: 'プライベートパーティー',
			note: '5〜7名様',
			includes: 'サラダ、餃子、枝豆、麺 + ミックスタンパク質',
			substitution: '同価格のタンパク質は交換可能',
		},
	},
	form: {
		name: 'お名前',
		namePlaceholder: 'フルネームを入力',
		email: 'メールアドレス',
		emailPlaceholder: 'メールを入力',
		phone: '電話番号',
		phonePlaceholder: '電話番号を入力',
		date: 'イベント日',
		time: 'ご希望の時間',
		guests: 'ゲスト人数',
		guestsHint: '最少10名様',
		region: '地域を選択',
		eventType: 'イベントタイプ',
		message: '追加メッセージ',
		messagePlaceholder: 'イベントについてお知らせください...',
		selectOption: '選択してください',
		selectDate: '日付を選択',
		submit: '送信',
		submitting: '送信中...',
		submitReservation: '予約を送信',
		success: '予約完了！',
		successMessage: '2時間以内に詳細確認のためご連絡いたします。',
		weWillContact: '詳細確認のため近日中にご連絡いたします。',
		error: '問題が発生しました。再度お試しいただくか、お電話ください。',
		required: '必須',
		people: '名',
		noPaymentRequired: '* 今すぐのお支払いは不要です。確認のためご連絡いたします。',
		invalidEmail: '有効なメールアドレスを入力してください',
		invalidPhone: '有効な電話番号を入力してください',
		eventTypes: {
			birthday: '誕生日パーティー',
			anniversary: '記念日',
			graduation: '卒業',
			corporate: '企業イベント',
			holiday: 'ホリデーパーティー',
			other: 'その他',
		},
		referralSource: '当店をどこでお知りになりましたか？',
		referral: {
			google: 'Google検索',
			friend: '友人の紹介',
			event: 'イベントで見た',
			other: 'その他',
		},
		couponCode: 'クーポンコード',
		couponPlaceholder: 'クーポンコードを入力（任意）',
		applyCoupon: '適用',
	},
	estimate: {
		title: '無料見積もり',
		subtitle: 'イベント内容をお教えいただければカスタム見積もりをご提供します',
		benefits: {
			title: '選ばれる理由',
			professional: 'プロ訓練を受けたシェフ',
			fresh: '新鮮な高品質食材',
			entertainment: 'ライブクッキングエンターテイメント',
			cleanup: '完全なセットアップと片付け',
			custom: 'カスタマイズ可能なメニュー',
		},
	},
	bookNow: {
		title: '鉄板焼きパーティー予約',
		subtitle: '以下のフォームに記入して日程を予約',
		selectRegion: 'まず、地域を選択してください',
		formTitle: 'イベント詳細',
		pricing: '$45/名様〜',
		note: '2時間以内に空き状況を確認いたします',
	},
	notFound: {
		title: 'ページが見つかりません',
		description: 'お探しのページは存在しません。',
		backHome: 'ホームへ戻る',
	},
	common: {
		learnMore: '詳細',
		viewAll: 'すべて見る',
		loading: '読み込み中...',
		close: '閉じる',
		backToHome: 'ホームへ',
		total: '合計',
		toBeConfirmed: '確認待ち',
		specialOffer: '特別オファー',
		goTo: '移動',
		previous: '前へ',
		next: '次へ',
	},
	topBar: {
		textUs: 'テキスト',
		email: 'メール',
	},
	photoShare: {
		title: '写真を共有',
		subtitle: '鉄板焼き体験を共有して、次回イベント$25割引！',
		option1Title: 'Instagramに投稿',
		option1Desc: '@familyfriendshibachiをタグ付けし#FamilyFriendsHibachiを使用',
		option2Title: '直接アップロード',
		option2Desc: '写真を共有してください',
		dropzone: 'ここに写真をドラッグ＆ドロップするかクリックして参照',
		maxFiles: '最大5枚',
		instagramPlaceholder: 'Instagramユーザー名（任意）',
		submit: '写真を送信',
		submitting: 'アップロード中...',
		successTitle: '写真が送信されました！',
		successDesc: '共有ありがとうございます！$25クレジットが次回予約に適用されます。',
		terms: '* 写真審査後にクレジットが適用されます。写真はSNSで紹介される場合があります。',
	},
	offer: {
		noTravel: '交通費無料',
		within50: '50マイル以内',
		noHidden: '隠れた料金なし',
		exclusive: '限定割引',
		freeSetup: 'テーブル・椅子無料',
		sunFri: '日曜〜金曜特別価格！',
	},
	coupon: {
		minGuests: '最低{{count}}名必要',
		applied: 'クーポン適用！割引: {{discount}}',
		invalid: '無効なクーポンコード',
		checkFailed: '確認に失敗しました',
		under15: '15名未満',
		range15to25: '15〜25名',
		range25to35: '25〜35名',
		over35: '35名以上',
	},
	privacy: {
		title: 'プライバシーポリシー',
		lastUpdated: '最終更新: 2026年1月',
		section1: {
			title: '1. 収集する情報',
			intro: 'Family Friends Hibachi サービスをご利用いただく際、以下の情報を収集する場合があります：',
			contact: '連絡先情報',
			contactDesc: '氏名、メールアドレス、電話番号',
			booking: '予約詳細',
			bookingDesc: 'イベント日時、場所、ゲスト数',
			payment: '支払い情報',
			paymentDesc: '第三者決済サービスを通じて安全に処理',
			usage: '利用データ',
			usageDesc: '当ウェブサイトとのやり取り方法',
		},
		section2: {
			title: '2. 情報の利用方法',
			item1: '予約の処理と確認',
			item2: '予約確認とリマインダーの送信',
			item3: 'お問い合わせへの対応',
			item4: 'サービスの改善',
			item5: 'プロモーションの送信（同意がある場合）',
		},
		section3: {
			title: '3. 情報の共有',
			intro: '個人情報を販売することはありません。以下と情報を共有する場合があります：',
			item1: '業務を支援するサービスプロバイダー',
			item2: '法律で要求される場合の当局',
		},
		section4: {
			title: '4. データセキュリティ',
			desc: '個人情報を保護するため、適切なセキュリティ対策を講じています。ただし、インターネット通信は100%安全ではありません。',
		},
		section5: {
			title: '5. お客様の権利',
			intro: '以下の権利があります：',
			item1: '個人データへのアクセス',
			item2: '不正確なデータの訂正要求',
			item3: 'データの削除要求',
			item4: 'マーケティング通信のオプトアウト',
		},
		section6: {
			title: '6. クッキー',
			desc: 'ブラウジング体験の向上とサイトトラフィックの分析のためにクッキーを使用します。ブラウザ設定でクッキーを制御できます。',
		},
		section7: {
			title: '7. お問い合わせ',
			intro: 'プライバシーに関するご質問：',
		},
	},
	terms: {
		title: '利用規約',
		lastUpdated: '最終更新: 2026年1月',
		section1: {
			title: '1. サービス',
			desc: 'Family Friends Hibachi は出張鉄板焼きケータリングサービスを提供しています。プロのシェフと機材をお客様の場所にお届けし、本格的な鉄板焼き料理を調理します。',
		},
		section2: {
			title: '2. 予約',
			minimum: '最低人数',
			minimumDesc: '最低10名様から',
			confirmation: '確認',
			confirmationDesc: 'スタッフから連絡後に予約確定',
			deposit: 'デポジット',
			depositDesc: '日程確保のためデポジットが必要な場合があります',
			finalCount: '最終人数',
			finalCountDesc: 'イベント48時間前までに人数確定が必要',
		},
		section3: {
			title: '3. キャンセルポリシー',
			sevenDays: '7日以上前',
			sevenDaysDesc: 'デポジット全額返金',
			threeSixDays: '3〜6日前',
			threeSixDaysDesc: 'デポジット50%返金',
			lessThanThree: '3日未満',
			lessThanThreeDesc: 'デポジット返金不可',
			weather: '天候',
			weatherDesc: '悪天候の場合は無料で日程変更',
		},
		section4: {
			title: '4. お客様の責任',
			intro: 'お客様にご用意いただくもの：',
			item1: '十分な屋外調理スペース（最低10x10フィート）',
			item2: '電源アクセス（50フィート以内の標準コンセント）',
			item3: 'ゲスト用のテーブルと椅子',
			item4: '必要に応じて天候保護（テント、ガゼボなど）',
		},
		section5: {
			title: '5. 食品安全とアレルギー',
			desc: 'ご予約時に食物アレルギーや食事制限をお知らせください。注意を払いますが、鉄板焼き調理の性質上、完全にアレルゲンフリーの環境を保証することはできません。',
		},
		section6: {
			title: '6. 責任',
			desc: 'Family Friends Hibachi は賠償責任保険に加入しています。ただし、お客様はゲストと財産に対する責任を負います。ゲストの行動や既存の財産状態による事故については責任を負いません。',
		},
		section7: {
			title: '7. サービスエリア',
			intro: '現在のサービスエリア：',
			california: 'カリフォルニア（ロサンゼルス、サンディエゴ、サンフランシスコおよび周辺地域）',
			texas: 'テキサス（ヒューストン、ダラス、オースティン、サンアントニオおよび周辺地域）',
			florida: 'フロリダ（マイアミ、フォートローダーデールおよび周辺地域）',
			travelFee: '標準サービスエリア外の場所には交通費がかかる場合があります。',
		},
		section8: {
			title: '8. 規約の変更',
			desc: 'これらの規約はいつでも変更する権利を留保します。サービスを継続して使用することは、更新された規約への同意を意味します。',
		},
		section9: {
			title: '9. お問い合わせ',
			intro: '規約に関するご質問：',
		},
	},
	status: {
		pending: '保留中',
		confirmed: '確定',
		completed: '完了',
		cancelled: 'キャンセル',
	},
	timeSlot: {
		afternoon: '午後',
		evening: '夕方',
		night: '夜',
	},
	admin: {
		login: {
			title: '管理者ログイン',
			subtitle: 'パスワードを入力してください',
			password: 'パスワード',
			loginButton: 'ログイン',
			loggingIn: 'ログイン中...',
			invalidPassword: 'パスワードが違います',
			loginFailed: 'ログイン失敗',
			contactHelp: 'ヘルプ',
		},
		dashboard: {
			title: '管理ダッシュボード',
			logout: 'ログアウト',
		},
		stats: {
			totalBookings: '合計',
			pending: '保留中',
			confirmed: '確認済み',
			completed: '完了',
			cancelled: 'キャンセル',
			totalGuests: '総ゲスト数',
		},
		tabs: {
			all: 'すべて',
			pending: '保留中',
			confirmed: '確認済み',
			completed: '完了',
			cancelled: 'キャンセル',
		},
		booking: {
			noBookings: '予約なし',
			noBookingsHint: '予約はここに表示されます',
			guests: '名様',
			booking: '予約',
			estimate: '見積もり',
			contactInfo: '連絡先情報',
			eventDetails: 'イベント詳細',
			date: '日付',
			time: '時間',
			notSpecified: '未指定',
			region: '地域',
			additionalNotes: '追加メモ',
			updateStatus: 'ステータス更新',
			emailCustomer: 'メール送信',
			callCustomer: '電話する',
		},
	},
};

export default ja;

